import ENDPOINTS from 'constants/endpoints';
import { toSearchString } from 'utils/url';

const postWithCredentials = async (url, payload) => {
    const result = await fetch(url, {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        credentials: 'include',
        body: payload
    })
        .then(response => {
            return response.json();
        })
        .then(data => {
            return data;
        })
        .catch(reason => {
            return { error: { reason } };
        });
    return result;
};

const saveSearch = async (savedSearchName, categoryId, searchTerm) => {
    const payloadObject = {
        savedQueryName: savedSearchName,
        categoryId: categoryId,
        q: searchTerm
    };

    const payload = toSearchString(payloadObject, {
        addQueryPrefix: false,
        encode: false
    });
    const url = ENDPOINTS.SAVED_SEARCH_ADD;
    return await postWithCredentials(url, payload);
};

const removeSavedSearch = async savedSearchId => {
    const url = ENDPOINTS.SAVED_SEARCH_REMOVE;
    const payload = toSearchString(
        { ids: savedSearchId },
        { addQueryPrefix: false }
    );
    return await postWithCredentials(url, payload);
};

const saveEmailNotificationEnabled = async (searchId, shouldSend) => {
    const url = ENDPOINTS.SAVED_SEARCH_NOTIFICATION;
    const payload = toSearchString(
        {
            SearchId: searchId,
            SendMail: shouldSend
        },
        {
            addQueryPrefix: false,
            encode: false
        }
    );
    return await postWithCredentials(url, payload);
};

export default {
    saveSearch,
    removeSavedSearch,
    saveEmailNotificationEnabled
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/save-search-button-data-service.js